export default function Footer() {
  return (
    <footer className="w-full bg-[#1e2708] border-t-2 border-[#c8e04a]/20 pt-10 pb-6 px-4">
      <div className="max-w-5xl mx-auto flex flex-col items-center gap-8">

        {/* Box loghi partner */}
        <div className="w-full max-w-[998px] flex items-center justify-center px-4 py-2">
          <img
            src="https://static.readdy.ai/image/2500ac09d0252d19a03ba42d5ab6c3f1/879e8ef7d8fb2b884a7489d89186b3b8.png"
            alt="Loghi Partner Festa della Tammorra 2026"
            className="w-full h-auto object-contain"
          />
        </div>

        {/* Divisore */}
        <div className="w-full flex items-center gap-4">
          <div className="h-px flex-1 bg-[#c8e04a]/20" />
          <div className="w-1.5 h-1.5 rounded-full bg-[#c8e04a]/40" />
          <div className="h-px flex-1 bg-[#c8e04a]/20" />
        </div>

        {/* Footer text */}
        <div className="flex flex-col items-center gap-1 text-center">
          <p className="font-['Londrina_Solid'] text-white text-lg md:text-xl tracking-widest uppercase">
            FESTA DELLA TAMMORRA 2026 - 24 &amp; 25 APRILE
          </p>
          <p className="font-['Londrina_Solid'] text-white/60 text-base tracking-wider">
            Villa Comunale, Parete (Ce) &mdash; Powered by Associazione la Tenda
          </p>
        </div>
      </div>
    </footer>
  );
}
